<template>
  <div class="qcrb-serviceAdmin">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.crmid"/>
          <el-form label-width="120px">
            <el-col :span="24">
              <div class="basic-title"><em>报名材料</em></div>
            </el-col>
            <el-col :span="24">
              <jm-materialCloud
                upload-url="/newfib.php/index/apply_file/upload"
                :upload-data="crmOfferId"
                :upload-position="{
                  upload_position: '报名材料',
                  offer_school_id: 0
              }"/>
            </el-col>
          </el-form>
          <el-form
            v-if="formProcess.zailiuData.schools !== ''"
            ref="formStay"
            :model="formStay"
            label-width="140px">
            <el-col :span="24">
              <div class="basic-title">
                <em>申请追踪</em>
                <el-select
                  @change="lockSchange"
                  :class="lockClassc ? 'title-select lockSelect active' : 'title-select lockSelect'"
                  size="mini"
                  v-model="formProcess.zailiuData.write_school_id"
                  placeholder="请选择">
                  <el-option
                    v-for="item in formProcess.zailiuData.schools"
                    :value="item.id"
                    :label="item.name"
                    :key="item.id"/>
                </el-select>
                <el-button
                  :disabled="lockBtn"
                  :class="lockClassc ? 'lockBtn active' : 'lockBtn'"
                  type="primary"
                  @click="lockChange"
                  size="mini">{{ lockClassc ? '开启' : '取消' }}</el-button>
              </div>
            </el-col>
            <div class="relative-area">
              <div :class="lockClassc ? 'mask-area active' : 'mask-area'"/>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="在留截止日期：">
                    <el-date-picker
                      :editable="false"
                      :clearable="false"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      v-model="formProcess.zailiuData['zailiu_deadline']"/>
                  </el-form-item>
                  <el-form-item label="在留材料签收：">
                    <jm-dict-select
                      class="jm-input135"
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="formProcess.zailiuData.is_zailiu_received"
                      name="handleReceived"/>
                    <span class="time-default">{{ formProcess.zailiuData['is_zailiu_received_time'] }}</span>
                  </el-form-item>
                  <el-form-item label="宿舍申请是否成功：">
                    <jm-dict-select
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="formProcess.zailiuData.is_dormitory_apply"
                      name="handleYesNo"/>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="通知准备在留材料：">
                    <jm-dict-select
                      class="jm-input135"
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="formProcess.zailiuData.is_zailiu_notified"
                      name="handleNotice"/>
                    <span class="time-default">{{ formProcess.zailiuData['is_zailiu_notified_time'] }}</span>
                  </el-form-item>
                  <el-form-item label="在留下达：" class="form-title-red">
                    <jm-dict-select
                      class="jm-input135"
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="formProcess.zailiuData.zailiu_status"
                      name="handleStatus"/>
                    <span class="time-default">{{ formProcess.zailiuData['zailiu_status_time'] }}</span>
                    <jm-upload-file
                      style="display: inline-block;margin-left: 10px"
                      url="/newfib.php/index/apply_file/upload"
                      :upload-data="crmOfferId"
                      :show-file-list='true'
                      :upload-additional="{
                        no_need_init: true,
                        upload_position: '在留下达',
                        upload_type_str: '在留下达',
                        offer_school_id: 0
                    }">
                      <template slot="uploadFile">
                        <el-button type="primary">上传在留文件</el-button>
                      </template>
                    </jm-upload-file>
                  </el-form-item>
                  <el-form-item label="宿舍选拔时间：">
                    <el-date-picker
                      :editable="false"
                      :clearable="false"
                      type="date"
                      placeholder="选择日期"
                      v-model="formProcess.zailiuData['dormitory_date']"/>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="在留材料邮寄：">
                    <jm-dict-select
                      class="jm-input135"
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="formProcess.zailiuData.is_zailiu_posted"
                      name="handlePosted"/>
                    <span class="time-default">{{ formProcess.zailiuData['is_zailiu_posted_time'] }}</span>
                  </el-form-item>
                  <el-form-item label="有无宿舍：">
                    <jm-dict-select
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="formProcess.zailiuData.is_dormitory"
                      name="handleDorm"/>
                  </el-form-item>
                  <el-form-item label="邮箱材料是否交接：">
                    <jm-dict-select
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="formProcess.zailiuData.is_mail_exchange"
                      name="handleYesNo"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="offer是否下达：" class="form-title-red">
                    <jm-dict-select
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="formProcess.zailiuData.is_offer_send"
                      name="handleYesNo"/>
                    <jm-upload-file
                      style="display: inline-block;margin-left: 10px"
                      url="/newfib.php/index/apply_file/upload"
                      :upload-data="crmOfferId"
                      :show-file-list='true'
                      :upload-additional="{
                        no_need_init: true,
                        upload_position: 'offer下达',
                        upload_type_str: 'offer下达',
                        offer_school_id: 0
                      }"
                    >
                      <template slot="uploadFile">
                        <el-button type="primary">上传offer文件</el-button>
                      </template>
                    </jm-upload-file>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="是否赴日：" class="form-title-red">
                    <jm-dict-select
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="formProcess.zailiuData.goto_japan"
                      name="handleYesNo"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-col :span="8">
                <div class="basic-padding2">
                  <template v-if="formProcess.zailiuData.write_school_id !=='' && typeof formProcess.zailiuData.write_school_id !== 'undefined'">
                    <jm-upload-file
                      url="/newfib.php/index/apply_file/upload"
                      ref="zailiuProcessUpload"
                      :upload-data="crmOfferId"
                      :show-file-list='true'
                      :upload-additional="{
                        upload_position: '在留材料清单',
                        upload_type_str: '在留材料清单',
                        offer_school_id: offerSchoolId
                    }">
                      <template slot="uploadFile">
                        <el-button type="primary">上传材料清单</el-button>
                        <!-- <div class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
                      </template>
                    </jm-upload-file>
                  </template>
                </div>
              </el-col>
              <el-col :span="24">
                <template v-if="(formProcess.zailiuData.write_school_id !== '') && (typeof formProcess.zailiuData.write_school_id !== 'undefined')">
                  <jm-materialCloud
                    ref="zailiuProcess"
                    upload-url="/newfib.php/index/apply_file/upload"
                    :upload-data="crmOfferId"
                    :upload-position="{
                      upload_position: '在留材料',
                      offer_school_id: offerSchoolId
                  }"/>
                </template>
              </el-col>
            </div>
            <el-col :span="24">
              <div class="basic-title"><em>办理完成交接材料</em></div>
            </el-col>
            <el-col :span="8">
              <div class="basic-padding2">
                <template v-if="formProcess.schoolList.length > 0">
                  <jm-upload-file
                    url="/newfib.php/index/apply_file/upload"
                    :upload-data="crmOfferId"
                    :show-file-list='true'
                    :upload-additional="{
                      upload_position: '材料云盘',
                      upload_type_str: '材料云盘',
                      offer_school_id: 0
                  }">
                    <template slot="uploadFile">
                      <el-button type="primary">上传材料</el-button>
                    <!-- <div class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
                    </template>
                  </jm-upload-file>
                </template>
              </div>
            </el-col>
          </el-form>
          <div class="qcrb-wrap-line"/>
          <div class="clearfix"/>
          <el-form
            v-if="formProcess.schoolList.length > 0"
            ref="formProlist"
            :model="formProlist"
            label-width="170px">
            <el-col :span="24">
              <div class="basic-padding2">
                <el-button
                  @click="sortClick"
                  type="primary"
                  size="mini">按预计出愿时间排序</el-button>
              </div>
            </el-col>
            <div class="clearfix"/>
            <!-- 流程 start-->
            <el-collapse
              class="table-agile-info"
              v-model="activeNames">
              <el-collapse-item
                v-for="(item, index) in formProcess.schoolList"
                :class="item.confirm_date === null || item.confirm_date === '' ? 'disabled-dropdown' : ''"
                :key="item.id"
                :name="item.id">
                <template slot="title">
                  <a :id="`s_${item.id}`"/>
                  <span>流程{{ index+1 }}：{{ item.sh_name }}&nbsp;-&nbsp;{{ item.org_name }}</span>
                  <div
                    class="jm-show"
                    @click.stop>
                    <jm-dict-select
                      class="title-select"
                      size="mini"
                      type="dataset"
                      dict-type="qcrb"
                      v-model="item.status"
                      name="serviceStatus"/>
                  </div>
                  <div class="jm-show">
                    <jm-dict-select
                      class="title-select qcrb-apply-title"
                      size="mini"
                      type="dataset"
                      :show="true"
                      dict-type="qcrb"
                      v-model="item.stage"
                      name="applyStatus"/>
                  </div>
                  <span class="title-right">预计出愿时间：{{ item.expect_date }}</span>
                </template>
                <el-col :span="24">
                  <div class="basic-title"><em>研究计划及面试材料</em></div>
                </el-col>
                <div class="basic-padding2">
                  <el-col :span="8">
                    <jm-upload-file
                      url="/newfib.php/index/apply_file/upload"
                      :upload-data="crmOfferId"
                      :show-file-list='true'
                      :upload-additional="{
                        upload_position: '研究计划终版',
                        upload_type_str: '研究计划书',
                        offer_school_id: item.offer_school_id
                    }">
                      <template slot="uploadFile">
                        <el-button type="primary">上传研究计划</el-button>
                      </template>
                    </jm-upload-file>
                  </el-col>
                  <el-col :span="8">
                    <jm-upload-file
                      url="/newfib.php/index/apply_file/upload"
                      :upload-data="crmOfferId"
                      :show-file-list='true'
                      :upload-additional="{
                        upload_position: '面试指导材料',
                        upload_type_str: '面试指导材料',
                        offer_school_id: item.offer_school_id
                    }">
                      <template slot="uploadFile">
                        <el-button type="primary">上传面试指导材料</el-button>
                      </template>
                    </jm-upload-file>
                  </el-col>
                </div>
                <el-col :span="24">
                  <div class="basic-title"><em>出愿</em></div>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="出愿截止日期：">
                    <el-date-picker
                      :editable="false"
                      :clearable="false"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      v-model="item.apply_deadline"/>
                  </el-form-item>
                  <el-form-item label="出愿材料签收：">
                    <jm-dict-select
                      class="jm-input135"
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="item.is_apply_received"
                      name="handleReceived"/>
                    <span class="time-default">{{ item.is_apply_received_time }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="通知准备出愿材料：">
                    <jm-dict-select
                      class="jm-input135"
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="item.is_apply_notified"
                      name="handleNotice"/>
                    <span class="time-default">{{ item.is_apply_notified_time }}</span>
                  </el-form-item>
                  <el-form-item label="入学许可下达：">
                    <jm-dict-select
                      class="jm-input135"
                      @change="(current) => statusLinkage(current, index)"
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="item.apply_status"
                      name="handleStatus"/>
                    <span class="time-default">{{ item.apply_status_time }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="出愿材料邮寄：">
                    <jm-dict-select
                      class="jm-input135"
                      clearable
                      type="dataset"
                      dict-type="qcrb"
                      v-model="item.is_apply_posted"
                      name="handlePosted"/>
                    <span class="time-default">{{ item.is_apply_posted_time }}</span>
                  </el-form-item>
                </el-col>
                <div class="basic-padding">
                  <el-col :span="8">
                    <jm-upload-file
                      url="/newfib.php/index/apply_file/upload"
                      :upload-data="crmOfferId"
                      :show-file-list='true'
                      :upload-additional="{
                        upload_position: '出愿材料清单',
                        upload_type_str: '出愿材料清单',
                        offer_school_id: item.offer_school_id
                    }">
                      <template slot="uploadFile">
                        <el-button type="primary">上传材料清单</el-button>
                      </template>
                    </jm-upload-file>
                  </el-col>
                </div>
                <jm-materialCloud
                  upload-url="/newfib.php/index/apply_file/upload"
                  :upload-data="crmOfferId"
                  :upload-position="{
                    upload_position: '出愿',
                    offer_school_id: item.offer_school_id
                }"/>
                <div v-if="checkingHidden(index)">
                  <el-col :span="24">
                    <div class="basic-title"><em>事前审查</em></div>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="事前审查截止日期：">
                      <el-date-picker
                        :editable="false"
                        :clearable="false"
                        type="date"
                        placeholder="选择日期"
                        v-model="item.checking_deadline"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="通知准备事前审查材料：">
                      <jm-dict-select
                        clearable
                        type="dataset"
                        dict-type="qcrb"
                        v-model="item.is_checking_notified"
                        name="handleNotice"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="事前审查材料是否通过：">
                      <jm-dict-select
                        clearable
                        type="dataset"
                        dict-type="qcrb"
                        v-model="item.checking_status"
                        name="handleCheckPost"/>
                    </el-form-item>
                  </el-col>
                  <jm-materialCloud
                    upload-url="/newfib.php/index/apply_file/upload"
                    :upload-data="crmOfferId"
                    :upload-position="{
                      upload_position: '事前审查',
                      offer_school_id: item.offer_school_id
                  }"/>
                </div>
                `<div v-if="item.same_as_leaving === 1">
                  <el-col :span="24">
                    <div class="basic-title"><em>院生出愿</em></div>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="出院截止日期：">
                      <el-date-picker
                        :editable="false"
                        :clearable="false"
                        type="date"
                        placeholder="选择日期"
                        v-model="item.leaving_deadline"/>
                    </el-form-item>
                    <el-form-item label="出院材料签收：">
                      <jm-dict-select
                        clearable
                        type="dataset"
                        dict-type="qcrb"
                        v-model="item.is_leaving_received"
                        name="handleReceived"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="通知准备出院材料：">
                      <jm-dict-select
                        clearable
                        type="dataset"
                        dict-type="qcrb"
                        v-model="item.is_leaving_notified"
                        name="handleNotice"/>
                    </el-form-item>
                    <el-form-item label="入学许可下达：">
                      <jm-dict-select
                        @change="(current) => statusLinkage(current, index)"
                        clearable
                        type="dataset"
                        dict-type="qcrb"
                        v-model="item.leaving_status"
                        name="handleStatus"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="出院材料邮寄：">
                      <jm-dict-select
                        clearable
                        type="dataset"
                        dict-type="qcrb"
                        v-model="item.is_leaving_posted"
                        name="handlePosted"/>
                    </el-form-item>
                  </el-col>
                  <div class="basic-padding">
                    <el-col :span="8">
                      <jm-upload-file
                        url="/newfib.php/index/apply_file/upload"
                        :upload-data="crmOfferId"
                        :show-file-list='true'
                        :upload-additional="{
                          upload_position: '流程材料清单',
                          upload_type_str: '流程材料清单',
                          offer_school_id: item.offer_school_id
                      }">
                        <template slot="uploadFile">
                          <el-button type="primary">上传材料清单</el-button>
                        </template>
                      </jm-upload-file>
                    </el-col>
                  </div>
                  <jm-materialCloud
                    upload-url="/newfib.php/index/apply_file/upload"
                    :upload-data="crmOfferId"
                    :upload-position="{
                      upload_position: '院生出愿',
                      offer_school_id: item.offer_school_id
                  }"/>
                </div>
              </el-collapse-item>
            </el-collapse>
            <!-- 流程 end-->
          </el-form>
          <el-col :span="24">
            <div class="basic-padding2">
              <el-button
                @click="onSubmit"
                type="primary">提交保存</el-button>
            </div>
          </el-col>
        </div>
        <div
          class="draft-area"
          v-show="draftHidden">
          <el-button
            type="primary"
            @click="draftLoad">加载草稿</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import materialCloud from '@/components/tool/materialCloud';
import { jmUploadFile, jmDictSelect } from '@/components/tool';

export default {
  data() {
    return {
      crmId: null,
      processList: null,
      formStay: {},
      activeNames: 0,
      formProcess: {
        schoolList: [],
        zailiuData: {
          write_school_id: '',
          zailiu_deadline: '',
          dormitory_date: ''
        }
      },
      formProlist: {},
      lockClassc: false,
      lockBtn: false,
      lockSh1: '',
      lockSh2: '',
      sortInt: 1,
      crmOfferId: {}, // 公共id
      formDraft: {},
      draftHidden: false, // 草稿开关
      offerSchoolId: '', // 特殊处理
      oldOfferSchoolId: '', // 特殊处理 旧offerId
    };
  },
  methods: {
    /**
     * 保存提交
     */
    onSubmit() {
      let student = {
        ...this.formProcess,
      };
      this.$http._post({
        url: '/index/qc_process/saveSchoolList?type=service',
        data: student,
      }).then(() => {
        this.$message.success('保存成功');
        this.getProcess();
      });
    },
    /**
     * 获取用户所有数据
     */
    getProcess() {
      if (!this.crmId) {
        return Promise.reject(new Error('无效的用户'));
      }
      return this.$http._get({
        url: `/index/qc_process/getSchoolList/crmid/${this.crmId}`
      }).then((data) => {
        this.formProcess = data.data;
        if (!this.formProcess.zailiuData.write_school_id) {
          this.formProcess.zailiuData.write_school_id = '';
        }
        if (this.formProcess.zailiuData.schools.length !== 0) {
          this.lockClassc = true;
          this.lockBtn = false;
          this.formProcess.zailiuData.schools.forEach((tab) => {
            if (tab.current === 1) {
              this.lockSh1 = tab.id;
              this.lockClassc = false;
              this.lockBtn = false;
            }
          });
          if (this.formProcess.zailiuData.schools.length <= 0) {
            this.formProcess.zailiuData = [];
          }
        } else {
          this.lockClassc = true;
          this.lockBtn = true;
        }
        this.crmOfferId = {
          crm_id: data.data.crm_id,
          offer_id: data.data.offer_id,
        };
      });
    },
    /**
     * 申请方式判断是否选中事前审查
     */
    checkingHidden(index) {
      if (this.formProcess.schoolList[index].apply_type.includes('7')) {
        return true;
      }
    },
    /**
     * 判断在留学校是否改变，如果改变清空表单
     */
    lockChange() {
      this.lockClassc = !this.lockClassc;
      if (this.lockClassc === false) {
        if (this.lockSh1 !== this.lockSh2) {
          this.lockSh1 = this.lockSh2;
          this.zailiuEmpty();
          this.zailiuProcess();
          this.formProcess.zailiuData.zailiu_deadline = '';
          this.formProcess.zailiuData.is_zailiu_received = '';
          this.formProcess.zailiuData.is_dormitory_apply = '';
          this.formProcess.zailiuData.is_zailiu_notified = '';
          this.formProcess.zailiuData.zailiu_status = '';
          this.formProcess.zailiuData.dormitory_date = '';
          this.formProcess.zailiuData.is_zailiu_posted = '';
          this.formProcess.zailiuData.is_dormitory = '';
          this.formProcess.zailiuData.is_mail_exchange = '';
        }
      }
    },
    /**
     * 切换在留学校清空数据
     */
    zailiuEmpty() {
      this.$http._get({
        url: '/index/qc_process/updateZailiu',
        data: {
          write_id: this.formProcess.zailiuData.write_id,
          write_school_id: this.formProcess.zailiuData.write_school_id
        }
      }).then(() => {
        this.getProcess();
      });
    },
    /**
     * 在留处理
     */
    zailiuProcess() {
      // 在留材料
      this.$http._post({
        url: '/index/apply_file/index',
        data: {
          ...this.crmOfferId,
          offer_school_id: this.offerSchoolId,
          upload_position: '在留材料',
          country_id: 485
        }
      }).then(() => {
        this.$refs.zailiuProcess.getDiskInfo();
      });
      // 在留材料清单
      this.$http._post({
        url: '/index/apply_file/index',
        data: {
          ...this.crmOfferId,
          offer_school_id: this.offerSchoolId,
          upload_position: '在留材料清单',
          upload_type_str: '在留材料清单',
          country_id: 485
        }
      }).then(() => {
        this.$refs.zailiuProcessUpload.getUploadInfo();
      });
    },
    /**
     * 在留学校改变
     */
    lockSchange(value) {
      this.lockSh2 = value;
      this.formProcess.zailiuData.write_school_id = value;
      this.formProcess.zailiuData.schools.forEach((item) => {
        if (item.id === value) {
          this.offerSchoolId = item.offer_school_id;
        }
      });
    },
    /**
     * 排序点击
     */
    sortClick() {
      this.formProcess.schoolList.sort((a, b) => {
        a = (new Date(a.expect_date || null)) * 1;
        b = (new Date(b.expect_date || null)) * 1;
        return this.sortInt > 0 ? (a - b) : (b - a);
      });
      this.sortInt = 0 - this.sortInt;
    },
    /**
     * 自动保存
     */
    autoSave() {
      setInterval(() => this.onDraftSubmit(), 30000);
    },
    /**
     * 获取草稿
     */
    getDraft() {
      if (!this.crmId) {
        return false;
      }
      this.$http._get({
        url: `/index/qc_process/getDraft?type=service&crmid=${this.crmId}`
      }).then((data) => {
        this.formDraft = data.data;
        if (this.formDraft !== '') {
          this.draftHidden = true;
        }
        if (!this.formDraft.zailiuData.write_school_id) {
          this.formDraft.zailiuData.write_school_id = '';
        }
        if (this.formDraft.zailiuData.schools.length !== 0) {
          this.lockClassc = true;
          this.lockBtn = false;
          this.formDraft.zailiuData.schools.forEach((tab) => {
            if (tab.current === 1) {
              this.lockSh1 = tab.id;
              this.lockClassc = false;
              this.lockBtn = false;
            }
          });
          if (this.formDraft.zailiuData.schools.length <= 0) {
            this.formDraft.zailiuData = [];
          }
        } else {
          this.lockClassc = true;
          this.lockBtn = true;
        }
        this.crmOfferId = {
          crm_id: data.data.crm_id,
          offer_id: data.data.offer_id,
        };
      });
    },
    /**
     * 自动草稿提交
     */
    onDraftSubmit() {
      let student = {
        ...this.formProcess,
      };
      this.$http._post({
        url: '/index/qc_process/saveDraft?type=service',
        data: student,
      }).then(() => {
        this.$message.success('已自动保存草稿');
      });
    },
    /**
     * 加载草稿
     */
    draftLoad() {
      this.formProcess = this.formDraft;
      this.draftHidden = false;
      this.$message.success('已加载草稿');
    },
    /**
     * 办理状态联动
     */
    statusLinkage(val, index) {
      if (val === 30) {
        this.formProcess.schoolList[index].status = 30;
      }
    }
  },
  mounted() {
    this.crmId = this.$route.params.crmid;
    this.$nextTick(() => {
      this.getProcess().then(() => {
        if (this.$route.hash) {
          this.activeNames = this.$route.hash.replace('#s_', '') - 0;
        }
      });
    });
    this.getDraft();
    this.autoSave();
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-materialCloud': materialCloud,
    jmUploadFile,
    jmDictSelect
  },
};
</script>
<style scoped>
  .basic-padding{
    display: block;
    clear: both;
    padding:0 10px;
  }
  .basic-padding:after{
    display: block;
    content: "";
    clear: both;
  }
  .basic-padding2{
    padding:20px 10px;
    text-align: left;
  }
  .title-right{
    float: right;
    margin-right: 12px;
  }
  .lockBtn{
    background-color: #8391a5;
    border-color: #8391a5;
  }
  .lockBtn.active{
    background-color: #20a0ff;
    border-color: #20a0ff;
  }
  .relative-area{
    clear: both;
    position: relative;
    overflow: hidden;
  }
  .relative-area .mask-area{
    position: absolute;
    left:0;
    top:0;
    width: 100%;
    height:100%;
    z-index: 1;
    display: none;
  }
  .relative-area .mask-area.active{
    display: block;
    cursor: no-drop;
  }
  .qcrb-wrap-line{
    margin: 20px 0;
    border-top:1px solid #ddd;
    clear: both;
  }
  .time-default{
    color: #999;
    padding: 0 10px;
  }
</style>
<style>
  .title-select{
    line-height:22px;
    margin:0 10px;
  }
  .qcrb-apply-title {
    background: none;
    pointer-events: none;
  }

  .qcrb-apply-title i {
    display: none;
  }
  .lockSelect .el-input__inner{
    background-color: #8391a5;
    color: #fff;
    pointer-events: none;
  }
  .lockSelect.active .el-input__inner{
    background-color: #fff;
    color: #1f2d3d;
    pointer-events: auto;
  }
  .lockSelect .el-input__icon{
    pointer-events: none;
  }
  .lockSelect.active .el-input__icon{
    pointer-events: auto;
  }
  .draft-area{
    position: fixed;
    bottom:30px;
    left:10px;
  }
  .disabled-dropdown{
    pointer-events: none;
  }
  .table-agile-info .disabled-dropdown .el-collapse-item__header{
    background: #ccc !important;
  }
</style>
